import styled from 'styled-components'

import Select from 'components/SelectV2'

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  flex-grow: 1;
  width: 100%;
  height: 100%;
`

export const FormInputs = styled.div`
  display: flex;
  padding: 12px 16px 12px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  flex: 1 0 0;
  overflow-y: auto;
`

export const InputsSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;

  > h4 {
    color: #006736;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    margin: 0;
    text-transform: none;
  }

  .rowsWrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    align-self: stretch;
  }
`

export const CustomInputsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  align-self: stretch;

  ${({ column }) =>
    column &&
    `
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  `}

  > label {
    height: 25px;
    align-self: stretch;
    color: #3e3e3e;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
    margin: 0;
    text-transform: unset;

    b {
      color: #f00;
      font-style: normal;
      font-weight: 400;
    }
  }
`

export const RadiosWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex: 1 0 0;
`

export const StyledSelect = styled(Select)`
  width: 100%;

  > div:first-child {
    height: 40px;
  }

  > div {
    padding: 10px;
    border: 1px solid #bababa;

    color: #616161;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Nunito;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
  }
`

export const InputLabel = styled.label`
  height: 25px;
  align-self: stretch;
  color: #3e3e3e;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  text-transform: unset;
  margin: 0;
`

export const WrapperSelect = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
  width: 100%;

  > label {
    height: 25px;
    align-self: stretch;
    color: #3e3e3e;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */

    b {
      color: #f00;
      font-style: normal;
      font-weight: 400;
    }
  }
`

export const Error = styled.span`
  display: inline-block;
  font-size: 12px;
  color: indianred;
  text-align: left;
`



// WEBPACK FOOTER //
// ./src/components/JoinTariffModalV2/components/styles.js